const KEY = "ael_pre_reg_session";
const SOURCE_KEY = "ael_pre_reg_source";

export function getPreRegSessionId() {
  try {
    if (typeof sessionStorage === "undefined") return null;
    let id = sessionStorage.getItem(KEY);
    if (!id) {
      id =
        globalThis.crypto?.randomUUID?.() ||
        `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

export function getPreRegSourceFlow() {
  try {
    if (typeof sessionStorage === "undefined") return null;
    return sessionStorage.getItem(SOURCE_KEY);
  } catch {
    return null;
  }
}

export function setPreRegSourceFlow(source) {
  try {
    if (typeof sessionStorage === "undefined") return;
    if (sessionStorage.getItem(SOURCE_KEY)) return; // set once, never overwrite
    sessionStorage.setItem(SOURCE_KEY, source);
  } catch {}
}

export function clearPreRegSession() {
  try {
    if (typeof sessionStorage === "undefined") return;
    sessionStorage.removeItem(KEY);
    sessionStorage.removeItem(SOURCE_KEY);
    sessionStorage.removeItem("ael_pre_reg_utm_sent");
  } catch {}
}
